import { paymentStatementApi } from './base';

export interface ConciergeTurn {
	role: 'user' | 'assistant';
	content: string;
}

export interface ConciergeConversation {
	page: string;
	context: Record<string, unknown>;
	statement_id?: string;
	messages: ConciergeTurn[];
}

export interface ConciergeAnswer {
	answer: string | null;
	source: 'app' | 'platform' | null;
	escalate: boolean;
}

export interface ConciergeTicket {
	id: string;
	status: string;
	created_at: string;
}

export const conciergeApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		askConcierge: builder.mutation<ConciergeAnswer, ConciergeConversation>({
			query: (body) => ({ url: '/concierge/messages', method: 'POST', body }),
		}),
		openConciergeTicket: builder.mutation<
			ConciergeTicket,
			ConciergeConversation & { detail: string }
		>({
			query: (body) => ({ url: '/concierge/tickets', method: 'POST', body }),
		}),
	}),
});

export const { useAskConciergeMutation, useOpenConciergeTicketMutation } =
	conciergeApi;
